import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=3c430024&"
import script from "./ServiceInformation.vue?vue&type=script&lang=ts&"
export * from "./ServiceInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceInformation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports